import { gsap } from 'gsap';

if (!customElements.get('modal-window')) {
  customElements.define(
    'modal-window',
    class ModalWindow extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[data-modal-trigger]');
        this.target = this.querySelector('[data-modal-target]');
        this.close = this.querySelectorAll('[data-modal-close]');
        this.modalWindow = this.querySelector('[data-modal-window]');
        this.body = this.closest('body');
        this.originalParent = this.target.parentNode;

        this.trigger.addEventListener('click', this.openModal.bind(this));

        this.close.forEach((button) => {
          button.addEventListener('click', this.closeModal.bind(this));
        });

        window.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeModal();
          }

          window.addEventListener('resize', this.closeModal.bind(this));
        });

        this.animateModal = gsap.from(this.modalWindow, {
          opacity: 0,
          scale: 0,
          yPercent: 50,
          duration: 0.3,
          paused: true,
          ease: 'back.out(1)',
        });
      }

      openModal() {
        document.body.appendChild(this.target);
        this.target.classList.remove('hidden');
        this.body?.classList.add('modal-is-open');
        this.animateModal.play();
      }

      closeModal() {
        this.animateModal.reverse();
        this.body?.classList.remove('modal-is-open');
        setTimeout(() => {
          this.target.classList.add('hidden');
          if (this.originalParent) {
            this.originalParent.appendChild(this.target);
          }
        }, 300);
      }
    }
  );
}
